// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message[data-v-d759b704] {\n  color: var(--magic-text-dark, #231f20);\n}", ""]);
// Exports
module.exports = exports;
